import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useAudienceDetailState } from '@pages/audience/lib/AudienceDetailContext'
import { NO_DATA_ID } from '@pages/audience/model/constant'
import BasicCard from '@pages/audience/ui/AudienceDetail/AudienceDetailAnalysis/Charts/_shared/BasicCard'
import EmptyData from '@pages/audience/ui/AudienceDetail/AudienceDetailAnalysis/Charts/_shared/EmptyData'
import { useGetAudienceSummaryUserProfileSummaryQuery } from '@shared/api/rtkQuery'
import { getIntSafe } from '@shared/lib/utils/number'

import useGroupData from '../_shared/hooks/useGroupData'
import HorizontalBarChart from './HorizontalBarChart'

const MemberStatus = () => {
  const { t } = useTranslation(['audience'])
  const { audienceId } = useAudienceDetailState()

  const { data, isError, isSuccess, isFetching, isLoading, isUninitialized } =
    useGetAudienceSummaryUserProfileSummaryQuery(
      { audienceId, type: 'member_status' },
      {
        skip: audienceId === NO_DATA_ID,
      }
    )

  const chartTitle = useMemo(() => {
    if (!data) {
      return ''
    }

    return t(`audience:${data.orderedByCountSummary[0].groupName}`)
  }, [data, t])

  const groupNameData = useGroupData({
    orderedByCountSummary: data?.orderedByCountSummary,
  })

  return (
    <BasicCard
      chartName="memberStatus"
      isFetching={isFetching}
      isSuccess={isSuccess}
      isLoading={isUninitialized || isLoading}
      isError={isError}
      subject={t('audience:main_grade')}
      title={chartTitle}
      nonMembers={getIntSafe(data?.totalNonMembers, '').toLocaleString()}
    >
      {data ? (
        <HorizontalBarChart
          categories={groupNameData.map(({ groupName }) => groupName)}
          series={groupNameData.map(({ count }) => count)}
          total={data.totalMembers}
        />
      ) : (
        <EmptyData />
      )}
    </BasicCard>
  )
}

export default MemberStatus
